import { render, staticRenderFns } from "./DestaquesPromocoes.vue?vue&type=template&id=1a908f18&scoped=true&"
import script from "./DestaquesPromocoes.vue?vue&type=script&lang=js&"
export * from "./DestaquesPromocoes.vue?vue&type=script&lang=js&"
import style0 from "./DestaquesPromocoes.vue?vue&type=style&index=0&id=1a908f18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a908f18",
  null
  
)

export default component.exports